export {
  default,
  getServerSideProps,
} from 'src/pages/products/[categoryOrCode]/[code]';
